import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import IOwner from 'src/models/IOwner';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import { FormApi } from 'final-form';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Suffixes from 'src/models/Suffixes';
import Prefixes from 'src/models/Prefixes';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IBusinessOwnerFormProps {
    handleOnSubmit: (formValues: IOwner) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

interface IBusinessOwnerFormState {
    form: FormApi;
}

class BusinessOwnerForm extends React.Component<IBusinessOwnerFormProps, IBusinessOwnerFormState> {
    constructor(props: IBusinessOwnerFormProps) {
        super(props);
        this.state = { form: undefined };
    }

    componentWillUnmount(): void {
        this.setState({ form: undefined });
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'businessOwner.name')) {
            _.set(errors, 'businessOwner.name', 'Required');
        }
        if (!_.get(values, 'businessOwner.contactPersonFirstName')) {
            _.set(errors, 'businessOwner.contactPersonFirstName', 'Required');
        }
        if (!_.get(values, 'businessOwner.contactPersonLastName')) {
            _.set(errors, 'businessOwner.contactPersonLastName', 'Required');
        }
        return errors;
    };

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerBusiness(formValues.businessOwner);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();

        const ownerBusiness = this.props.ownerData.ownerDetails as OwnerBusiness;

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>Business Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    style={{padding: '3rem'}}
                    initialValues={{ businessOwner: ownerBusiness }}
                    validate={this.validateForm}
                    onFormCreated={(form) => {
                        this.setState({ form: form });
                    }}
                    hasFieldArray={true}
                >
                    <div style={{width: '100%', textAlign: 'center'}}>
                        <FormTextBox 
                            name="businessOwner.name" 
                            label="Business Name" 
                            className="lh-half-width"
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="businessOwner.ssnTaxId" 
                            label="Tax Id" 
                            className="lh-half-width" 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Contact Person</legend>
                    </fieldset>
                    <div style={{width: '100%'}}>
                        <FormTextBox 
                            name="businessOwner.contactPersonTitle" 
                            label="Title" 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="businessOwner.contactPersonPrefix" 
                            items={Prefixes} 
                            label="Prefix" 
                            className="lh-third-width"
                        />
                        <FormSelect 
                            name="businessOwner.contactPersonSuffix" 
                            items={Suffixes} 
                            label="Suffix" 
                            style={{marginLeft: '.5rem'}}
                            className="lh-third-width"
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <FormTextBox 
                            name="businessOwner.contactPersonFirstName" 
                            label="First Name" 
                            className="lh-fourth-width"
                            isRequired={true} 
                        />
                        <FormTextBox
                            name="businessOwner.contactPersonMiddleName" 
                            label="Middle Name"  
                            className="lh-fourth-width"
                        />
                        <FormTextBox 
                            name="businessOwner.contactPersonLastName" 
                            label="Last Name" 
                            isRequired={true} 
                            className="lh-fourth-width" 
                            style={{marginLeft: '.5rem'}}
                        />
                        <FormTextBox 
                            name="businessOwner.email" 
                            label="Email" 
                            className="lh-fourth-width" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Address</legend>
                    </fieldset>
                    <div style={{width: '100%'}}>
                        <FormTextBox 
                            name="businessOwner.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-full-width"
                        />
                        <FormTextBox 
                            name="businessOwner.address.addressLine2" 
                            label="Address Line 2"
                            className="lh-full-width"
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <FormTextBox 
                            name="businessOwner.address.city" 
                            label="City" 
                            className="lh-third-width" 
                        />
                        <FormSelect
                            name="businessOwner.address.stateId"
                            label="State"
                            items={selectStates}
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="businessOwner.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                    <div>
                        <FormCheckbox 
                            name="businessOwner.isClientAcreage" 
                            label="This is the Client" 
                        />
                    </div>
                    <div style={{marginLeft: '.5rem'}}>
                        <MultiplePhoneNumber 
                            baseFieldName="businessOwner" 
                            form={this.state.form} 
                            phoneNumberTypes={this.props.phoneNumberTypes} 
                        />
                    </div>
                    <div className="button-row">
                        <Button 
                            text="Save" 
                            type="submit" 
                            intent="primary" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                </Form>
            </div>
        );
    }
}

export default BusinessOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/BusinessOwnerForm.tsx